import Swiper from 'swiper/js/swiper';
// import Plyr from 'plyr';
import { gsap } from 'gsap/dist/gsap';
// eslint-disable-next-line no-unused-vars
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  init() {
    // JavaScript to be fired on the home page

    /**************************************************************
    -> Pageload animation
    **************************************************************/
    function pageAboutLoadAnimation() {
      const tl = gsap.timeline({ delay: 0.5, duration: 0.5 })

      tl.to('.hero-about .wrap-fullscreen-image', { opacity: 1 })
      .to('.hero-about .dark-overlay-hero', { opacity: 1 }, '>-0.15')
      .to('.hero-about .wrap-hero-header h1', { opacity: 1 }, '>-0.25')
    }
    pageAboutLoadAnimation()

    /**************************************************************
    -> About intro anim on scroll
    **************************************************************/
   function inViewAnimAboutIntro() {
    gsap.fromTo('.wrap-text-and-landscape h2' , 
    { opacity: 0 },
    {
      opacity: 1,
      delay: 0.25,
      duration: 0.5,
      scrollTrigger: '.intro-about .wrap-text-and-landscape',
    })

    gsap.fromTo('.wrap-text-and-landscape p' , 
    { opacity: 0 },
    {
      opacity: 1,
      delay: 0.5,
      duration: 0.5,
      scrollTrigger: '.intro-about .wrap-text-and-landscape',
    })

    gsap.fromTo('.wrap-text-and-landscape .link-to' , 
    { opacity: 0 },
    {
      opacity: 1,
      delay: 0.5,
      duration: 0.5,
      scrollTrigger: '.intro-about .wrap-text-and-landscape p',
    })

    gsap.fromTo('.wrap-image-portrait' , 
    { opacity: 0},
    {
      opacity: 1,
      delay: 0.25,
      duration: 0.5,
      scrollTrigger: '.intro-about .wrap-text-and-landscape',
    })

    gsap.fromTo('.wrap-text-and-landscape .image' , 
    { opacity: 0 },
    {
      opacity: 1,
      delay: 0.5,
      duration: 0.5,
      scrollTrigger: '.intro-about .link-to',
    })

    gsap.fromTo('.wrap-carousel-logo-intro' , 
    { opacity: 0 },
    {
      opacity: 1,
      delay: 0.5,
      duration: 0.5,
      scrollTrigger: '.wrap-carousel-logo-intro',
    })

  }
  inViewAnimAboutIntro();

  /**************************************************************
    -> About Why choose us anim on scroll
    **************************************************************/
   function inViewAnimAboutWhy() {
    gsap.fromTo('.why-chose-us-about h2' , 
    { opacity: 0 },
    {
      opacity: 1,
      delay: 0.25,
      duration: 0.5,
      scrollTrigger: '.why-chose-us-about .wrap-text-and-landscape',
    })

    gsap.fromTo('.swiper-container-about-why-choose-us-pagination' , 
    { opacity: 0 },
    {
      opacity: 1,
      delay: 0.25,
      duration: 0.5,
      scrollTrigger: '.why-chose-us-about .swiper-container-about-why-choose-us-pagination',
    })

    gsap.fromTo('.why-chose-us-about .swiper-wrapper' , 
    { opacity: 0 },
    {
      opacity: 1,
      delay: 0.5,
      duration: 0.5,
      scrollTrigger: '.why-chose-us-about .swiper-wrapper',
    })
  }
  inViewAnimAboutWhy();

  /**************************************************************
    -> About our team anim on scroll
    **************************************************************/
   function inViewAnimAboutTeam() {
    // gsap.fromTo('.our-team-about h2' , 
    // { opacity: 0 },
    // {
    //   opacity: 1,
    //   delay: 0.25,
    //   duration: 0.5,
    //   scrollTrigger: '.our-team-about h2',
    // })

    // gsap.fromTo('.our-team-about p' , 
    // { opacity: 0 },
    // {
    //   opacity: 1,
    //   delay: 0.5,
    //   duration: 0.5,
    //   scrollTrigger: '.our-team-about p',
    // })

    gsap.fromTo('.wrap-full-team-carousel .wrap-carousel' , 
    { opacity: 0 },
    {
      opacity: 1,
      delay: 0.25,
      duration: 0.5,
      scrollTrigger: '.our-team-about .wrap-full-team-carousel .wrap-carousel',
    })

    gsap.fromTo('.our-team-about .wrap-team-member-infos' , 
    { opacity: 0 },
    {
      opacity: 1,
      delay: 0.5,
      duration: 0.5,
      scrollTrigger: '.our-team-about .wrap-full-team-carousel .wrap-team-member-infos',
    })
  }
  inViewAnimAboutTeam();

    /**************************************************************
    -> About our team anim on scroll
    **************************************************************/
    function inViewAnimAboutVideo() {
      gsap.fromTo('.video-about' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.video-about',
      })
    }
    inViewAnimAboutVideo();

    /**************************************************************
    -> About quotes anim on scroll
    **************************************************************/
    function inViewAnimAboutQuote() {
      gsap.fromTo('.clients-say-about h2' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.clients-say-about',
      })

      gsap.fromTo('.clients-say-about .wrap-carousel' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.clients-say-about h2',
      })
    }
    inViewAnimAboutQuote();

    /**************************************************************
    -> Home News anim on scroll
    **************************************************************/
    function inViewAnimNews() {
      gsap.fromTo('.news-and-press-home .wrap-text h2' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.news-and-press-home',
      })

      gsap.fromTo('.news-and-press-home .wrap-text .link-to' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.news-and-press-home',
      })

      gsap.fromTo('.news-and-press-home .wrap-news-row .news-item' , 
      { opacity: 0},
      {
        opacity: 1,
        delay: 0.5,
        duration: 0.5,
        ease: 'linear',
        stagger: {
          each: 0.08,
          from: 'start',
          grid: 'auto',
          ease: 'linear',
        },
        scrollTrigger: '.news-and-press-home',
      })

    }
    inViewAnimNews();

    /**************************************************************
    -> About Work with us anim on scroll
    **************************************************************/
    function inViewAnimAboutWorkWithUs() {
      gsap.fromTo('.work-with-us-about .wrap-image' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.work-with-us-about',
      })

      gsap.fromTo('.work-with-us-about .wrap-text .secondary-heading' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.work-with-us-about .wrap-text',
      })

      gsap.fromTo('.work-with-us-about .wrap-text .paragraph-style' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.5,
        duration: 0.5,
        scrollTrigger: '.work-with-us-about .wrap-text',
      })

      gsap.fromTo('.work-with-us-about .wrap-text .link-to' , 
      { opacity: 0},
      {
        opacity: 1,
        delay: 0.5,
        duration: 0.25,
        ease: 'linear',
        stagger: {
          each: 0.05,
          from: 'start',
          grid: 'auto',
          ease: 'linear',
        },
        scrollTrigger: '.work-with-us-about .wrap-text',
      })

    }
    inViewAnimAboutWorkWithUs();

    // Intro Logos Slider
    // eslint-disable-next-line no-unused-vars
    let AboutLogoSwiper = new Swiper ('.swiper-container-about-intro-logo-list', {
      loop: true,
      roundLengths: true,
      grabCursor: true,
      draggable: true,
      speed: 500,
      centeredSlides: true,
      navigation: {
        nextEl: '.swiper-about-intro-logos-next',
        prevEl: '.swiper-about-intro-logos-prev',
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 3,
          spaceBetween: 25,
        },
        // when window width is >= 760px
        760: {
          slidesPerView: 5,
          spaceBetween: 35,
        },
        // when window width is >= 1024px
        1024: {
          slidesPerView: 7,
          spaceBetween: 50,
        },
      },
    })

    // About Quote slider
    // eslint-disable-next-line no-unused-vars
    let AboutQuoteSwiper = new Swiper ('.swiper-container-about-clients-say', {
      loop: true,
      slidesPerView: 1,
      roundLengths: true,
      grabCursor: true,
      speed: 500,
      navigation: {
        nextEl: '.swiper-clients-say-button-next',
        prevEl: '.swiper-clients-say-button-prev',
      },
    })

    // Why choose us About slider 
    const getAllSlideTitles = document.querySelectorAll('.swiper-container-about-why-choose-us .swiper-slide')
    let slideTitles = [];

    for (var i = 0; i < getAllSlideTitles.length; i++) {
      slideTitles.push(getAllSlideTitles[i].getAttribute('data-title'))
    }

    // eslint-disable-next-line no-unused-vars
    let WhyChooseUsSwiper = new Swiper ('.swiper-container-about-why-choose-us', {
      loop: true,
      roundLengths: true,
      grabCursor: true,
      speed: 750,
      centeredSlides: true,
      navigation: {
        nextEl: '.swiper-why-button-next',
        prevEl: '.swiper-why-button-prev',
      },
      pagination: {
        el: '.swiper-container-about-why-choose-us-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + slideTitles[index] + '</span>';
        },
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1.2,
          spaceBetween: 15,
        },
        // when window width is >= 760px
        760: {
          slidesPerView: 1.5,
          spaceBetween: 35,
        },
        // when window width is >= 1024px
        1024: {
          slidesPerView: 2,
          spaceBetween: 195,
        },
      },
    })

       // eslint-disable-next-line no-unused-vars
       let OurTeamInfosSwiper = new Swiper('.swiper-container-about-our-team-infos', {
        loop: true,
        loopAdditionalSlides: 2,
        // loopedSlides: 2, //looped slides should be the same
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        speed: 200,
        allowTouchMove: false,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        // thumbs: {
        //   swiper: OurTeamSwiper,
        // },
      })

    // eslint-disable-next-line no-unused-vars
    let OurTeamSwiper = new Swiper('.swiper-container-about-our-team', {
      loop: true,
      loopAdditionalSlides: 2,
      // loopedSlides: 2, //looped slides should be the same
      // roundLengths: true,
      draggable: true,
      grabCursor: true,
      speed: 500,
      navigation: {
        nextEl: '.swiper-our-team-button-next',
        prevEl: '.swiper-our-team-button-prev',
      },
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1.8,
          spaceBetween: 15,
        },
        // when window width is >= 760px
        769: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
      },
      thumbs: {
        swiper: OurTeamInfosSwiper,
      },
    })

    // eslint-disable-next-line no-unused-vars
    // const player = new Plyr('#player', {
    //   controls: [
    //     'play-large', // The large play button in the center
    //     'play', // Play/pause playback
    //     // 'progress', // The progress bar and scrubber for playback and buffering
    //   ],
    // });

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/about.js